import React from 'react'

type Props = {
    title?      : string
    children    : React.ReactNode
    className?  : string
}

export default function QuickAdd_Group(props: Props) {
    
    const className = Classes("item-type-group-new", props.className)
    
    return (
        <div className={className}>
            {props.title &&
                <div className="group-title">
                    <div className="label">{props.title}</div>
                    <div className="line-through"/>
                </div>
            }

            {props.children}
        </div>
    )
}